import React from 'react';

import IconFemtasy from 'components/IconFemtasy';

import './style.scss';

interface IProps {
  actionMenuIconRef: React.RefObject<HTMLDivElement>;
  onClick: () => void;
}

const ThreeDotsMenu = ({ actionMenuIconRef, onClick }: IProps) => {
  return (
    <>
      <div ref={actionMenuIconRef}>
        <IconFemtasy
          key={2}
          className="menu"
          icon="More"
          size="24"
          onClick={onClick}
        />
      </div>
    </>
  );
};

export default ThreeDotsMenu;
